import { render, staticRenderFns } from "./modalEditOrder.vue?vue&type=template&id=526430d9&"
import script from "./modalEditOrder.vue?vue&type=script&lang=js&"
export * from "./modalEditOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports